export default __webpack_public_path__ + "static/media/shapes.2bfe55ed.svg";